export default __webpack_public_path__ + "static/media/Panorama-icon.7e5f38ea.png";